<template>
  <!-- eslint-disable vue/no-v-html -->
  <i
    :class="classes"
    :style="cssProps"
    v-html="svg"
  />
  <!--eslint-enable-->
</template>

<script>
import { computed, defineComponent, reactive } from 'vue';

export default defineComponent({
   
  name: 'Icon',
  components: {
  },
  props: {
    /**
     * PROP: icon
     * Icon name text.
     * Check Storybook to see list of icons available for each type.
     **/
    icon: {
      type: String,
      required: true,
    },
    /**
     * PROP: size
     * Size of the icon.
     * Can be any valid css unit.
     **/
    size: {
      type: String,
      default: '20px',
    },
    /**
     * PROP: color
     * The colour of the icon.
     * Can be any valid css colour syntax.
     **/
    color: {
      type: String,
      default: ""
    },
    /**
     * PROP: animateHover
     * Animates some/ all of the icon when hovered over
     * If the icon has a parent called icon-hover-container, the hover animation will trigger off that instead
     * Only for specific icons that have this developed
     * [hand-heart]
     **/
    animateHover: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
     
    props = reactive(props);
    return {
      classes: computed(() => ({
        icon: true,
        'icon-colored': props.color,
        'icon-animated': props.animateHover
      })),
    };
  },
  computed: {
    svg() {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.modules['/assets/icons/' + this.file];
      if(tempDiv.querySelector('svg')) {
        tempDiv.querySelector('svg').setAttribute("height", this.size);
        tempDiv.querySelector('svg').setAttribute("width", this.size); // Some extra with for non square icons
      }
      return tempDiv.innerHTML;
    },
    modules() {
      return import.meta.glob('@/assets/icons/*.svg', {
        query: '?raw',
        import: 'default',
        eager: true,
      });
    },
    file(){
      return this.icon?.trim() + '.svg';
    },
    cssProps(){
      return {
        '--icon-color': this.color,
        '--icon-size': this.size
      };
    }
  },
});
</script>

<style lang="scss">


.icon {
  display: inline-flex;
  height: var(--icon-size);
  width: auto;
  overflow: visible !important;
}
.icon svg {
  overflow: visible;
}

.icon.icon-colored svg path {
  fill: var(--icon-color);
}

// Defining custom animations for certain icons
.icon-hover-container:hover .icon.icon-animated {
  .heart {
    animation: heartPulse 0.6s ease-in-out;
    transform-origin: center;
  }
  .clock {
    transform-origin: center;
    animation: rotateRefresh 1s ease-in-out forwards;
  }
}
.icon-animated:not(.icon-hover-container *):hover .heart {
  animation: heartPulse 0.6s ease-in-out;
  transform-origin: center;
}
// Hand-heart icon
@keyframes heartPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
}

//History Icon
@keyframes rotateRefresh {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
